// extracted by mini-css-extract-plugin
export var root = "contact-module--root--36d0b";
export var navContainer = "contact-module--navContainer--ca697";
export var detailContainer = "contact-module--detailContainer--24c2f";
export var imageContainer = "contact-module--imageContainer--74a41";
export var content = "contact-module--content--76e91";